@if (nameOnly) {
  <div class="font-medium text-gray-900">{{ item.full_name }}</div>
} @else {
  <div class="space-y-0.5 py-1">
    <div class="font-medium text-gray-900">{{ item.full_name }}</div>
    <div class="text-xs text-gray-500">
      @if (item.email || item.mobile) {
        {{ item.email || '' }}{{ item.email && item.mobile ? ' · ' : '' }}{{ item.mobile || '' }}
      } @else {
        —
      }
    </div>
  </div>
}
